// extracted by mini-css-extract-plugin
module.exports = {"selected":"Drawer_selected__8Xsyx","disclaimer":"Drawer_disclaimer__1D9vN","sizeDisclaimer":"Drawer_sizeDisclaimer__38wyD","sizeMessage":"Drawer_sizeMessage__3H5_Q"};